"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EOSEndpointServiceIntent = void 0;
//import type IJellies from "@tmna/seal-interfaces/lib/IJellies";
//import type IJellyParams from "@tmna/seal-interfaces/lib/IJellyParams";
// Temporarily copying types in for SEAL
let EOSEndpointServiceIntent = exports.EOSEndpointServiceIntent = /*#__PURE__*/function (EOSEndpointServiceIntent) {
  EOSEndpointServiceIntent["VEHICLE_MANAGEMENT"] = "VEHICLE_MANAGEMENT";
  EOSEndpointServiceIntent["VEHICLE_HEALTH"] = "VEHICLE_HEALTH";
  EOSEndpointServiceIntent["VEHICLE_MAINTENANCE"] = "VEHICLE_MAINTENANCE";
  EOSEndpointServiceIntent["SERVICE_MANAGEMENT"] = "SERVICE_MANAGEMENT";
  EOSEndpointServiceIntent["VEHICLE_INFO"] = "VEHICLE_INFO";
  EOSEndpointServiceIntent["VEHICLE_SUBSCRIPTION"] = "VEHICLE_SUBSCRIPTION";
  return EOSEndpointServiceIntent;
}({}); // VHR Interfaces